import React, { useRef } from "react";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import JobCard from "../JobCard";
import PatternCircle from "@/assets/PatternCircle.svg";
import PatternSmall from "@/assets/2_a.svg";
import PatternBig from "@/assets/2_b.svg";
import NavLeft from "@/assets/NavLeft.svg";
import NavRight from "@/assets/NavRight.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Autoplay]);

const Jobs = ({ title, highlight, color_variant, items }) => {
  if (!items || items.length == 0) return <></>;

  const navigation = {
    prevEl: ".JobsSlider-prevEl",
    nextEl: ".JobsSlider-nextEl",
  };
  const autoplay = {
    delay: 1,
    disableOnInteraction: true,
    pauseOnMouseEnter: true,
    stopOnLastSlide: false,
  };
  const breakpoints = {
    500: {
      slidesPerView: 1,
    },
    760: {
      slidesPerView: 2,
    },
    1150: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 2
    },
    1400: {
      slidesPerView: 3
    }
  };

  return (
    <div className={classes.section}>
      <PatternSmall className={`fill ${color_variant} ${classes.pattern_small}`} />
  
      <div className={classes.heading}>
        <Title className={classes.title} title={title} tag="h4" highlight={highlight} variant={color_variant} />
        <div className={`${classes.swiper_nav}`}>
          <div className={`${classes.icon_button} ${classes.hover_effect} JobsSlider-prevEl`}>
            <NavLeft className={`${classes.icon} ${classes.arrow}`} />
          </div>
          <div className={`${classes.icon_button} ${classes.hover_effect} JobsSlider-nextEl`}>
            <NavRight className={`${classes.icon} ${classes.arrow}`} />
          </div>
          <PatternBig className={`fill ${color_variant} ${classes.pattern_big}`} />
        </div>
    
      </div>
      <div className={classes.list}>
        <Swiper
          loop
          effect={"slide"}
          speed={1000}
          navigation={navigation}
          modules={[Navigation, Autoplay]}
          // autoplay={autoplay}
          spaceBetween={10}
          breakpoints={breakpoints}
        >
          {items?.map((item, index) => (
            <SwiperSlide key={index}>
              <JobCard item={item}></JobCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={classes.footer}>
        <div className={`${classes.swiper_nav}`}>
          <div className={`${classes.icon_button} ${classes.hover_effect} JobsSlider-prevEl`}>
            <NavLeft className={`${classes.icon} ${classes.arrow}`} />
          </div>
          <div className={`${classes.icon_button} ${classes.hover_effect} JobsSlider-nextEl`}>
            <NavRight className={`${classes.icon} ${classes.arrow}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobs;
